
import * as echarts from 'echarts';
import common from "@/util/common";
import {defineComponent, toRefs, reactive, watch, onMounted, ref, nextTick} from "vue";
import { Progress } from '@souche-ui/vant-next';
//  interface State {
//         // bgcolor:  any;
//         // dataColor: any;
//         // data: number;

//     }
export default defineComponent({
    name: 'BatteryRadar',
    props: {
        renderData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        gaugeId: {
          type: String,
        },
        bgColor: {
          type: String,
        },
        dataColor: {
          type: Array,
        },
        data: {
          type: Number,
        },
        total: {
          type: Number,
        },
        dataShadowColor: {
          type: String
        }
    },
    setup(props: any) {
      // let state: State = reactive({
      //     // bgcolor:  'red',
      //     // dataColor: 'green',
      //     // data: 80,

      // })
      function setColorList() {
          // 检查 props.dataColor 是否存在且为数组
          if (!props.dataColor || !Array.isArray(props.dataColor) || props.dataColor.length === 0) {
            return [];
          }

          const colors = props.dataColor;
          const result: { offset: number; color: string }[] = [];
          
          // 如果只有一个颜色
          if (colors.length === 1) {
            return [{
              offset: 0,
              color: colors[0]
            }];
          }
          
          // 多个颜色时，等分分配 offset
          for (let i = 0; i < colors.length; i++) {
            result.push({
              offset: i / (colors.length - 1),
              color: colors[i]
            });
          }
          
          return result;
        }
        let chartInstance;
        const initChart = () => {
          const chartDom = document.getElementById(props.gaugeId);
          chartInstance = echarts.init(chartDom);
          console.log('initChart--gauge');
          
          const option = {
            // tooltip: {
            //   trigger: 'item'
            // },
            // grid: {
            //     left: '0',
            //     top: '0',
            //     right: '0',
            //     bottom: '0',
            // },
            series: [
              {
                  type: 'gauge',
                  radius: '100%',
                  startAngle: '225',
                  endAngle: '-45',
                  center: ['50%', '50%'],
                  min: 0,
                  max: 100,
                  pointer: {
                    show: false,
                  },
                  title: {
                    show: false,
                  },
                  detail: {
                    show: false,
                  },
                  data: [{
                    value: 100,
                    name: ''
                  }],
                  axisLine: {
                      lineStyle: {
                          color: [
                            [1, props.bgColor]
                          ],
                          width: 9,
                      },
                      opacity: 0
                  },
                  axisLabel: {
                      show: false,
                  },
                  axisTick: {
                      show: false,
                  },
                  splitLine: {
                      show: false,
                  },

              },
              {
                type: 'gauge',
                radius: '100%',
                startAngle: '225',
                endAngle: '-45',
                center: ['50%', '50%'],
                z: 3,
                pointer: {
                  show: false,
                },
                title: {
                  show: false,
                },
                detail: {
                  show: false,
                },
                data: [{
                  value: 100,
                  name: ''
                }],
                axisLine: {
                    lineStyle: {
                          color: [
                              [props.data / props.total, new echarts.graphic.LinearGradient(
                                  0, 1, 0, 0, setColorList()
                              )],
                              [
                                  1, 'rgba(28,128,245,.0)'
                              ]
                          ],
                          width: 9
                      }
                },
                axisLabel: {
                    show: false,
                },
                axisTick: {
                    show: false,
                },
                splitLine: {
                    show: false,
                },

              },
              {
                name: '外部刻度',
                type: 'gauge',
                radius: '85%',
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    show: false,
                    color: '#DBECFF',
                    distance: 25,
                },
                axisTick: {
                    show: false,
                    splitNumber: 17,
                    lineStyle: {
                        color: 'DBECFF',
                        width: 1,
                    },
                    length: 6,
                    // distance: -5
                },
                splitLine: {
                    show: true,
                    length: 6,
                    lineStyle: {
                        width: 1,
                        color: '#DBECFF',
                    },
                    distance: -5,
                },
                pointer: {
                    show: false
                }
              },
              {
                type: 'gauge',
                radius: '100%',
                z: 4,
                center: ['50%', '50%'],
                startAngle: 225-(270 * props.data/100) +1,
                endAngle: 225-(270 * props.data/100) -10,
                axisLine: {
                    lineStyle: {
                      color: [[1/3, '#fff']],
                      width: 9,
                      shadowColor: props.dataShadowColor,
                      shadowBlur: 10,
                    }
                },
                progress: { 
                  show: false,
                },
                axisLabel: {
                    show: false,
                },
                axisTick: {
                    show: false,
                },
                splitLine: {
                    show: false,
                },
                detail: {
                    show: false,
                },
                pointer: {
                    show: false,
                },
                data: [{
                  value: 100,
                  name: ''
                }],
              }
            ]
          };
          
          chartInstance.setOption(option);
          
          // 响应窗口大小变化
          window.addEventListener('resize', () => {
            chartInstance.resize();
          });
        };
        
        
        
        
        onMounted(() => {
          nextTick(() => {
            initChart();
          });
        });
        
        
        return {
            // state,
        };
      }
   
});
